import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const BillingHistory = ({ subscriptionData }) => {
  const [filterPeriod, setFilterPeriod] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  // Mock billing history data
  const billingHistory = [
    {
      id: 'INV-2026-001',
      date: '2026-01-25',
      description: 'Professional Plan - Monthly Subscription',
      amount: 149.00,
      status: 'paid',
      paymentMethod: 'Visa ****4242',
      downloadUrl: '#'
    },
    {
      id: 'INV-2025-012',
      date: '2025-12-25',
      description: 'Professional Plan - Monthly Subscription',
      amount: 149.00,
      status: 'paid',
      paymentMethod: 'Visa ****4242',
      downloadUrl: '#'
    },
    {
      id: 'INV-2025-011',
      date: '2025-11-25',
      description: 'Starter Plan - Monthly Subscription',
      amount: 49.00,
      status: 'paid',
      paymentMethod: 'Visa ****4242',
      downloadUrl: '#'
    },
    {
      id: 'INV-2025-010',
      date: '2025-10-25',
      description: 'Starter Plan - Monthly Subscription',
      amount: 49.00,
      status: 'paid',
      paymentMethod: 'Visa ****4242',
      downloadUrl: '#'
    }
  ];

  const statusConfig = {
    paid: { label: 'Paid', color: 'green', icon: 'CheckCircle' },
    pending: { label: 'Pending', color: 'yellow', icon: 'Clock' },
    failed: { label: 'Failed', color: 'red', icon: 'XCircle' },
    refunded: { label: 'Refunded', color: 'gray', icon: 'RotateCcw' }
  };

  const handleDownloadInvoice = (invoice) => {
    console.log('Downloading invoice:', invoice?.id);
    // In production, trigger actual download
  };

  const handleExportAll = () => {
    console.log('Exporting all billing history');
    // In production, generate CSV/PDF export
  };

  const totalPaid = billingHistory
    ?.filter(item => item?.status === 'paid')
    ?.reduce((sum, item) => sum + item?.amount, 0);

  return (
    <div className="space-y-6">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center">
              <Icon name="DollarSign" className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Total Paid</p>
              <p className="text-2xl font-bold text-gray-900">${totalPaid?.toFixed(2)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
              <Icon name="Receipt" className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Total Invoices</p>
              <p className="text-2xl font-bold text-gray-900">{billingHistory?.length}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center">
              <Icon name="Calendar" className="w-5 h-5 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Next Payment</p>
              <p className="text-lg font-semibold text-gray-900">
                {new Date(subscriptionData?.nextBillingDate)?.toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric'
                })}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Billing History Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">Billing History</h3>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              onClick={handleExportAll}
            >
              Export All
            </Button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Invoice ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Payment Method
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {billingHistory?.map((invoice) => {
                const status = statusConfig?.[invoice?.status];
                return (
                  <tr key={invoice?.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-medium text-gray-900">{invoice?.id}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-600">
                        {new Date(invoice?.date)?.toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric'
                        })}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm text-gray-900">{invoice?.description}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-600">{invoice?.paymentMethod}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-semibold text-gray-900">${invoice?.amount?.toFixed(2)}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-${status?.color}-100 text-${status?.color}-800`}>
                        <Icon name={status?.icon} className="w-3 h-3" />
                        {status?.label}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <Button
                        variant="ghost"
                        size="sm"
                        iconName="Download"
                        onClick={() => handleDownloadInvoice(invoice)}
                      >
                        Download
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Tax Information */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-start gap-3">
          <Icon name="FileText" className="w-5 h-5 text-gray-600 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">Tax Documentation</h3>
            <p className="text-sm text-gray-600 mb-4">
              All invoices include applicable taxes and are available for download. For tax reporting purposes, 
              you can export your complete billing history at any time.
            </p>
            <Button variant="outline" size="sm" iconName="Download">
              Download Tax Summary
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingHistory;